import React from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, Button, Checkbox } from 'react-bootstrap';
import Moment from 'moment';
import $ from 'jquery';
import I18n from 'i18n-react';
import OverviewSearchBar from '../../components/overviewSearchBar/OverviewSearchBar';
import Analytics from '../../components/modules/tudo-azul-analytics';
import LoginCookie from '../../components/loginCookie/LoginCookie';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import PassengerForm from '../../components/passengerInfo/passengerForm/PassengerForm';
import PassengersInfo from '../../const/PassengersInfo';
import ErrorsCodes from '../../const/ErrorsCodes';
import { isFromCallcenter } from '../../services/queryService/QueryService';

import RefreshTokenCallcenterProvider from '../../components/providers/refreshTokenCallcenter/RefreshTokenCallcenterProvider';
import './PassengersPage.css';

import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';
import InfoReloadModal from '../../components/common/bestPriceModal/InfoReloadModal';

import logoInfoTooltip from '../../assets/img/img-tooltip.svg';
import { wrap } from 'lodash';
import LocalStorage from '../../const/LocalStorage';
import BirthDateInfoModal from '../../components/passengerInfo/birthDateInfoModal/BirthDateInfoModal';

const ADULT = 'ADT';
const CHILD = 'CH';
const INFANT = 'IN';
const DATE_FORMAT = 'DD/MM/YYYY';

class PassengersPage extends React.Component {
  constructor() {
    super();
    this.state = {
      passengerIsChecked: false,
      analyticsDataJourney: {
        dataOrigin: null,
        dataReturn: null
      },
      cookieOnLoad: true,
      openModal: false,
      messageInfo: null,
      isRedirect: false,
      welcomeName: '',
      valueName: null,
      valueLastName: null,
      valueGender: null,
      valueAge: null,
      valueEmail: null,
      valuePassport: null,
      valueNationality: null,
      valueCountryPassport: null,
      valueExpirationDatePassport: null,
      modalInactity: false,
      isCallcenterEnabled: false,
      keepLoggedUser: false,
      pathname: '/',
      isFieldsEnabled: false,
      isModalVisible: true
    };
    this.modalInactivityListener = null;
    this.changeModalState = this.changeModalState.bind(this);
  }

  componentWillMount() {
    if (
      !this.props.location ||
      !this.props.location.state ||
      !this.props.location.state.quotationJourney ||
      !this.props.location.state.flightsFilter ||
      !this.props.location.state.analyticsDataSelect
    ) {
      this.setState({
        isRedirect: true
      });
    } else {
      this.setState({
        quotationJourney: this.props.location.state.quotationJourney,
        flightsFilter: this.props.location.state.flightsFilter,
        analyticsDataSelect: this.props.location.state.analyticsDataSelect,
        passengerInfo: this.getPassengerInfoList(this.props.location.state.flightsFilter),
        lastFlightDate: this.getLastFlightDate(this.props.location.state.quotationJourney),
        isCallcenterEnabled: this.props.location.state.isCallcenterEnabled || false
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.modalInactivityListener = EventEmitter.createListener(
      Listener.SHOW_MODAL_INACTIVITY,
      this.showModalInactivity
    );
    setTimeout(() => {
      this.setState({ openModalInf: true });
    }, 900000);
    if (this.callCenterMode()) this.setDataCustomerCallcenter();
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.modalInactivityListener);
  }

  showModalInactivity = errorType => {
    if (ErrorsCodes.CALLCENTER_ACCESS_DENIED_ERROR === errorType[0]) {
      this.setState({
        pathname: '/?callcenter=false'
      });
      this.showModal(I18n.translate('home.msg.error'));
    } else {
      this.setState({ modalInactity: true });
      this.showModal(I18n.translate('home.msg.session.callCenterExpired'));
    }
  };

  changeModalState = () => {
    if (this.state.isModalVisible === true) {
      return this.setState({
        isModalVisible: false
      });
    } else {
      this.setState({
        isModalVisible: true
      });
    }
  };

  getPassengerInfoList = filter => {
    let list = [];
    this.generatePassengers(list, filter.totalAdults, ADULT);
    this.generatePassengers(list, filter.totalKids, CHILD);
    this.generatePassengers(
      list,
      filter.totalBabys,
      INFANT,
      this.getPassengerAdultLis(filter.totalAdults)
    );
    return list;
  };

  generatePassengers = (list, total, type, adultPassengerList) => {
    for (let i = 0; i < total; i++) {
      let passenger = {
        passengerType: type,
        travellingWithValues: type === INFANT ? adultPassengerList : null,
        travellingWithDefaultValue: type === INFANT ? adultPassengerList[i] : null
      };
      list.push(passenger);
    }
  };

  getPassengerAdultLis(total) {
    let list = [];
    for (let i = 1; i <= total; i++) {
      list.push(
        I18n.translate('components.passengerInfo.travellingWith.adultPassenger', { number: i })
      );
    }
    return list;
  }

  getLastFlightDate = journey => {
    let lastFlightDate;
    if (journey.returnFlight) {
      const flights = journey.returnFlight.flight.flightGroup;
      lastFlightDate = flights[flights.length - 1].departureDate;
    } else {
      const flights = journey.departureFlight.flight.flightGroup;
      lastFlightDate = flights[flights.length - 1].departureDate;
    }
    return lastFlightDate;
  };

  trackingPassengers(data) {
    const dataSelect = this.state.analyticsDataSelect;
    const journey = this.state.quotationJourney;
    if (dataSelect && journey) {
      const originFlightSelected = this.getDataFlightSelected(journey.departureFlight);
      const returnFlightSelected = this.getDataFlightSelected(journey.returnFlight);
      const loginData = this.getLoginData(data);
      this.setState({
        analyticsDataJourney: {
          dataOrigin: originFlightSelected,
          dataReturn: returnFlightSelected
        },
        analyticsLogin: loginData
      });
      Analytics.trackingPassengers(
        dataSelect,
        originFlightSelected,
        returnFlightSelected,
        loginData
      );
    }
  }

  getLoginData(data) {
    return {
      username: data.username,
      firstName: data.firstName,
      lastName: data.lastName,
      pointsBalance: data.pointsBalance,
      nationalId: data.document.number,
      userClassification: data.userClassification,
      mobile: data.mobile,
      phone: data.phone,
      email: data.email,
      address: {
        country: data.address.country,
        region: data.address.region,
        city: data.address.city
      },
      passport: data.passport,
      nationality: data.nationality,
      countryPassport: data.countryPassport,
      expirationDatePassport: data.expirationDatePassport
    };
  }

  getDataFlightSelected(data) {
    let dataFlightSelected = null;
    if (data && data.flight) {
      const flightSelected = data.flight;
      dataFlightSelected = {
        origin: flightSelected.originAirport,
        destination: flightSelected.finalDestination,
        departureDate: this.getFormatDate(flightSelected.departureDate),
        departureTime: flightSelected.departureTime,
        adultsRevenuePoints: data.value,
        childrenRevenuePoints: data.childValue ? data.childValue : null,
        flights: flightSelected.flightGroup.map(flight => {
          return {
            flightNumber: flight.flightNumber,
            operatingCarrier: flight.operatingCarrier,
            origin: flight.origin,
            destination: flight.destination,
            isThroughFlight: flight.throughFlight
          };
        })
      };
    }
    return dataFlightSelected;
  }

  getFormatDate(date) {
    let formatDate = null;
    if (date) {
      formatDate = Moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    return formatDate;
  }

  alterSearch = () => {
    this.setState({
      isRedirect: true,
      keepLoggedUser: this.callCenterMode()
    });
  };

  proceedToCheckout = () => {
    this.setState({
      isRedirect: true,
      pathname: '/checkout'
    });
  };

  submitForm = () => {
    let hasError = false;
    hasError = this.validateInvalidFields();
    if (!hasError) {
      this.proceedToCheckout();
    }
  };

  validateInvalidFields() {
    let hasError = false;
    let usedAdult = [];
    this.itens.forEach(value =>
      value.fields.forEach(field => {
        let isValid = field.validate();
        if (!isValid && !hasError) {
          field.input.focus();
          hasError = true;
        }
        if (
          value.props.passengerType === INFANT &&
          field.props.id.indexOf('travellingWith') !== -1
        ) {
          if (usedAdult.indexOf(field.state.value) === -1) {
            usedAdult.push(field.state.value);
          } else {
            field.invalidateSelection('components.passengerInfo.travellingWith.invalidSelection');
            if (!hasError) {
              field.input.focus();
              hasError = true;
            }
          }
        }
      })
    );
    return hasError;
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    if (this.callCenterMode() && this.state.modalInactity) {
      document.location.assign(global.env.CALLCENTER_LOGOUT_URL);
    } else {
      this.setState({
        openModal: false,
        messageInfo: null,
        isRedirect: true
      });
    }
  }

  getValueGender(gender) {
    switch (gender) {
      case 'MALE':
        return PassengersInfo.GENDER_MALE;
      case 'FEMALE':
        return PassengersInfo.GENDER_FEMALE;
      default:
        return null;
    }
  }

  cookieCallback = data => {
    if (this.state.cookieOnLoad) {
      this.setState({
        cookieOnLoad: false
      });

      if (data) {
        this.trackingPassengers(data);
      }
    }

    if (data) {
      this.setDataValue(data);
    } else {
      this.showModal(I18n.translate('home.msg.session.expired'));
    }
  };

  setDataValue(data) {
    this.setState({
      welcomeName: data.firstName,
      valueName: data.firstName,
      valueLastName: data.lastName,
      valueAge: data.birthDate,
      valueEmail: data.email,
      valueGender: this.getValueGender(data.gender),
      valuePassport: data.passport,
      valueNationality: data.nationality,
      valueCountryPassport: data.countryPassport,
      valueExpirationDatePassport: data.expirationDatePassport,
      username: data.username
    });
  }

  setDataCustomerCallcenter() {
    const dataStorage = localStorage.getItem(LocalStorage.CUSTOMER_DATA_CALLCENTER);
    if (dataStorage) {
      const data = JSON.parse(dataStorage);
      this.trackingPassengers(data);
      this.setDataValue(data);
    } else {
      this.showModal(I18n.translate('home.msg.session.expired'));
    }
  }

  cleanInvalidFields = () => {
    if (!this.state.passengerIsChecked && !this.state.openModal) {
      this.itens[0].fields.forEach(field => {
        let isValid = field.validate();
        if (!isValid) {
          field.input.focus();
        }
      });
    }
  };

  onChangePassengerCheck = () => {
    this.setState(
      prevState => ({
        passengerIsChecked: !prevState.passengerIsChecked,
        isFieldsEnabled: !prevState.isFieldsEnabled,
        valueName: '',
        valueLastName: '',
        valueAge: '',
        valueEmail: '',
        valueGender: '',
        valuePassport: '',
        valueNationality: '',
        valueCountryPassport: '',
        valueExpirationDatePassport: ''
      }),
      this.cleanInvalidFields
    );
    this.checkedScroll();
    if (this.state.passengerIsChecked && this.callCenterMode()) {
      this.setDataCustomerCallcenter();
    }
  };

  renderCookie() {
    if ((this.state.cookieOnLoad || !this.state.passengerIsChecked) && !this.callCenterMode()) {
      return (
        <LoginCookie callbackCookie={this.cookieCallback} callcenterMode={this.callCenterMode()} />
      );
    }
  }

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }

  renderPassenger(passenger, index) {
    if (index > 0) {
      return (
        <PassengerForm
          id={index.toString()}
          passengerType={passenger.passengerType}
          lastFlightDate={this.state.lastFlightDate}
          passengerNumber={(index + 1).toString()}
          changeName={value => (passenger.name = value)}
          changeLastName={value => (passenger.lastName = value)}
          changeGender={value => (passenger.gender = value)}
          changeAge={value => (passenger.age = value)}
          changeEmail={value => (passenger.email = value)}
          changePassport={value => (passenger.passport = value)}
          changeNationality={value => (passenger.nationality = value)}
          changeCountryPassport={value => (passenger.countryPassport = value)}
          changeExpirationDatePassport={value => (passenger.expirationDatePassport = value)}
          changeTravellingWith={value => (passenger.travellingWith = value)}
          valueName={passenger.name ? passenger.name : null}
          valueLastName={passenger.lastName ? passenger.lastName : null}
          valueGender={passenger.gender ? passenger.gender : null}
          valueAge={passenger.age ? passenger.age : null}
          valueEmail={passenger.email ? passenger.email : null}
          valuePassport={passenger.passport ? passenger.passport : null}
          valueNationality={passenger.nationality ? passenger.nationality : null}
          valueCountryPassport={passenger.countryPassport ? passenger.countryPassport : null}
          valueExpirationDatePassport={
            passenger.expirationDatePassport ? passenger.expirationDatePassport : null
          }
          travellingWithDefaultValue={
            passenger.travellingWith
              ? passenger.travellingWith
              : passenger.travellingWithDefaultValue
          }
          ref={ref => (this.itens[index] = ref)}
          travellingWithValues={passenger.travellingWithValues}
          hidePassengerTitle={false}
          isFieldsEnabled={true}
          isRenderIconEdit={false}
          isCallcenterEnabled={this.state.isCallcenterEnabled}
          isPassengerComarch={false}
        />
      );
    }
    return (
      <PassengerForm
        id={index.toString()}
        passengerType={passenger.passengerType}
        lastFlightDate={this.state.lastFlightDate}
        passengerNumber={(index + 1).toString()}
        changeName={value => (passenger.name = value)}
        changeLastName={value => (passenger.lastName = value)}
        changeGender={value => (passenger.gender = value)}
        changeAge={value => (passenger.age = value)}
        changeEmail={value => (passenger.email = value)}
        changePassport={value => (passenger.passport = value)}
        changeNationality={value => (passenger.nationality = value)}
        changeCountryPassport={value => (passenger.countryPassport = value)}
        changeExpirationDatePassport={value => (passenger.expirationDatePassport = value)}
        valueName={this.state.valueName}
        valueLastName={this.state.valueLastName}
        valueGender={this.state.valueGender}
        valueAge={this.state.valueAge}
        valueEmail={this.state.valueEmail}
        valuePassport={this.state.valuePassport}
        valueNationality={this.state.valueNationality}
        valueCountryPassport={this.state.valueCountryPassport}
        valueExpirationDatePassport={this.state.valueExpirationDatePassport}
        ref={ref => (this.itens = [ref])}
        travellingWithValues={passenger.travellingWithValues}
        travellingWithDefaultValue={passenger.travellingWithDefaultValue}
        hidePassengerTitle={!this.state.passengerIsChecked}
        isFieldsEnabled={this.state.isFieldsEnabled}
        isRenderIconEdit={true}
        isCallcenterEnabled={this.state.isCallcenterEnabled}
        isPassengerComarch={!this.state.passengerIsChecked}
      />
    );
  }

  checkedScroll() {
    var header = $('#containerHeaderBar');
    var breadcrumb = $('#overviewBreadcrumb');
    var element = $('.PagePassengers__checkbox');
    $('html, body').animate(
      {
        scrollTop:
          element.offset().top -
          breadcrumb.height() -
          (header.hasClass('fixed') ? 0 : header.height())
      },
      300
    );
  }

  renderModalInfTime() {
    return (
      <InfoReloadModal
        id="modalinf"
        message={I18n.translate('components.checkoutInfo.modalInf.message')}
        showModal={this.state.openModalInf}
        firstOption={() => {
          window.history.back();
        }}
        iconTimer={true}
        ref={c => {
          this.modalRefundRulesDetailsError = c;
        }}
      />
    );
  }

  renderBirthDateInfoModal() {
    const dateValue = Moment(this.state.valueAge, DATE_FORMAT);
    const ageLimit = Moment()
      .subtract(100, 'years')
      .subtract(1, 'days');
    if (dateValue.isBefore(ageLimit)) {
      return (
        <BirthDateInfoModal
          onClose={() => this.changeModalState()}
          showModal={this.state.isModalVisible === true}
          isCallcenterEnabled={this.state.isCallcenterEnabled}
          isPassengerComarch={true}
        />
      );
    }
  }

  render() {
    return (
      <div id="pagePassengers">
        <RefreshTokenCallcenterProvider />
        {this.renderCookie()}
        <section className="container-fluid section__outer">
          {(() => {
            if (this.state.isRedirect) {
              return (
                <Redirect
                  push
                  to={{
                    pathname: this.state.pathname,
                    state: this.state,
                    search: this.props.location ? this.props.location.search : null
                  }}
                />
              );
            } else {
              return (
                <Row>
                  <Col xs={12}>
                    <OverviewSearchBar
                      origin={this.state.flightsFilter.flightOrigin.code}
                      destination={this.state.flightsFilter.flightDestiny.code}
                      departureDate={this.state.flightsFilter.startDate}
                      returnDate={this.state.flightsFilter.endDate}
                      totalAdults={this.state.flightsFilter.totalAdults}
                      totalKids={this.state.flightsFilter.totalKids}
                      totalBabys={this.state.flightsFilter.totalBabys}
                      alterSearchCallback={this.alterSearch}
                      alterFlightOverviewPrice={false}
                      quotationJourney={this.state.quotationJourney}
                      history={this.props.history}
                      steps={[
                        'components.steps.search',
                        'components.steps.flightSelection',
                        'components.steps.passengers'
                      ]}
                      stepsBreadcrumb={[
                        'components.steps.search',
                        'components.steps.flightSelection',
                        'components.steps.passengers'
                      ]}
                      actualStepBreadcrumb="components.steps.passengers"
                    />
                  </Col>
                  <Col xs={12} className="PagePassengers__body">
                    <Row>
                      <Col xs={12} className="collapsedFixedTitle">
                        <label className="PagePassengers__welcomeMessage">
                          {I18n.translate('passengers.welcomeMessage')}
                        </label>
                        <label>&nbsp;</label>
                        <label className="PagePassengers__welcomeMessage PagePassengers__welcomeName">
                          {this.state.welcomeName}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} className="PagePassengers__title">
                        <span>{I18n.translate('passengers.title')}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={8}>
                        <div
                          className={`PagePassengers__checkbox ${
                            this.state.passengerIsChecked ? 'checked' : ''
                          }`}>
                          <Checkbox
                            id="ckBxPassenger"
                            bsClass={`checkbox PagePassengers__checkbox--input ${
                              this.state.passengerIsChecked ? 'checked' : ''
                            }`}
                            onChange={this.onChangePassengerCheck}
                          />
                          <label htmlFor="ckBxPassenger" className="PagePassengers__checkbox--text">
                            {I18n.translate('passengers.checkbox')}
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <div className={'Container_passaporte'}>
                      <div className={'Passaporte'}>
                        <img
                          className={'Img_Logo_informativo'}
                          src={logoInfoTooltip}
                          alt="imagem que caracteriza informação importante referente"
                        />
                        <label>
                          <span className={'Passaporte_span'}>
                            {I18n.translate('passengers.passaporte')}
                          </span>
                        </label>
                      </div>
                    </div>
                    {this.state.passengerInfo.map((passenger, index) => (
                      <Row key={index}>
                        <Col xs={12} md={10} className="PagePassengers__form">
                          {this.renderPassenger(passenger, index)}
                        </Col>
                      </Row>
                    ))}
                    <Row>
                      <Col xs={12} className="PagePassengers__buttonRow">
                        <Button
                          id="btnProceedToCheckout"
                          className="PagePassengers__nextButton"
                          onClick={this.submitForm}>
                          {I18n.translate('passengers.nextButton')}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              );
            }
          })()}
        </section>
        <InfoModal
          id="modalPassengerInfo"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={() => this.closeModal()}
          ref={c => {
            this.modalPassengerInfo = c;
          }}
        />
        {this.renderModalInfTime()}
        {this.renderBirthDateInfoModal()}
      </div>
    );
  }
}
export default PassengersPage;



// WEBPACK FOOTER //
// ./src/page/passengers/PassengersPage.jsx